import Spinner from "@/components/Spinner";
import { useRef, useState } from "react";
import QRCode from "react-qr-code";
import { endpoints } from "../../../hooks/endpoints";
import { getToken } from "../../../hooks/utils";
import { useAppDispatch } from "../../../store/hooks";
import { pushModal } from "../../../store/slices/modalsSlice";
import GeneralMessageModal from "../../Modals/GeneralMessageModal";

const MobileWalletPurchase = ({
  lesson_id,
  amount,
}: {
  lesson_id: number;
  amount?: number;
}) => {
  const mobileRef = useRef(null);
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useAppDispatch();

  const handlePurchase = async () => {
    if (Number(amount) < 50)
      return dispatch(
        pushModal(
          <GeneralMessageModal msg="أقل قيمة للشحن هي 50 جنيه" btnMsg="حسنا" />
        )
      );
    if (Number(amount) > 10000)
      return dispatch(
        pushModal(
          <GeneralMessageModal
            msg="أقصى قيمة للشحن هي 10,000 جنيه"
            btnMsg="حسنا"
          />
        )
      );

    setError(null);
    if (!mobileRef.current.value) {
      setError("ادخل رقم المحفظة");
      return;
    }

    setIsPending(true);
    const res = await fetch(endpoints.fawaterakPurchase, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify({
        product_id: lesson_id,
        payment_method: 4,
        mobile_number: mobileRef.current.value,
        amount,
      }),
      // signal: abortCont.signal
    });
    const result = await res.json();

    if (!res.ok) {
      console.log(result);
      setError("حدث خطأ");
      setIsPending(false);
    } else {
      console.log("this is result: ", result);
      setData(result);
      setIsPending(false);
    }
  };

  return (
    <div className="block space-y-4">
      <div className="mx-auto w-full md:w-1/2">
        <label htmlFor="wallet-number" className="block mb-2 font-bold">
          أدخل رقم المحفظة
        </label>
        <input
          ref={mobileRef}
          id="wallet-number"
          type="text"
          className="block w-full rounded-lg border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
          onChange={(e) => {
            if (!e.target.value) return;
            const regex = /^\d+$/;
            if (regex.test(e.target.value ?? "")) {
              mobileRef.current.value = e.target.value;
              setError(null);
            } else {
              mobileRef.current.value = "";
              setError("مسموح بإدخال الأرقام فقط");
            }
          }}
        />
      </div>

      {!!error && (
        <p className="text-red-600 text-center">{error ?? ""}</p>
      )}

      {!isPending && (
        <button
          onClick={handlePurchase}
          className="block mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg hover:bg-primary/90 transition"
        >
          إرسال طلب الدفع
        </button>
      )}

      {isPending && (
        <button
          type="button"
          disabled
          className="gap-2 mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg flex items-center cursor-not-allowed"
        >
          <Spinner variant="button" />
          إرسال طلب الدفع...
        </button>
      )}

      {data && (
        <div className="flex">
          <div
            role="alert"
            className="mx-auto px-4 py-3 rounded-lg bg-green-100 border border-green-400 text-green-800 w-full md:w-auto text-center"
          >
            <p>
              سيقوم مزود خدمة المحفظة الإلكترونية الخاص بكم بإرسال رسالة إلى
              الرقم الذي أدخلته لإتمام عملية الدفع
            </p>
            <p className="mt-2">
              أو يمكنك الدفع عن طريق هذا ال QR كود من تطبيق المحفظة الإلكترونية
            </p>
            <QRCode
              size={256}
              style={{
                height: "auto",
                padding: ".5rem",
                backgroundColor: "#fff",
                borderRadius: "1rem",
              }}
              className="mx-auto mt-4"
              value={data.meezaQrCode}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileWalletPurchase;
